var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.998,
    height: 15.997,
    viewBox: "0 0 14.998 15.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.998,
    height: 15.997
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31 -115.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 115.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.075,2.616l-6-2.5a1.512,1.512,0,0,0-1.155,0l-6,2.5A1.5,1.5,0,0,0,0,4c0,6.2,3.577,10.49,6.921,11.883a1.5,1.5,0,0,0,1.152,0C10.752,14.767,15,10.914,15,4a1.5,1.5,0,0,0-.922-1.383M11.5,6.14,7.054,10.583a.386.386,0,0,1-.546,0L4,8.072a.387.387,0,0,1,0-.546l.546-.546a.387.387,0,0,1,.546,0L6.783,8.673l3.626-3.625a.385.385,0,0,1,.546,0l.546.546a.387.387,0,0,1,0,.546",
    transform: "translate(0 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield-icon.a480cc93664487b075adbacccf586a92.svg";
export { ForwardRef as ReactComponent };